















































































import { Component, Prop } from 'vue-property-decorator';
import Form from '@/layouts/Form';
import { SubscriptionCard } from '@/types/models/subscriptions';
import { Errors } from '@/types/common';

import InputBase from "@/components/input/Input.vue";
import NumericInput from '@/components/input/NumberInput.vue';
import ErrorField from '@/components/form/ErrorField.vue';
import DatepickerPopup from '@/components/datepicker/DatepickerPopup.vue';
import InputSuggestions from '@/components/input/InputSuggestions.vue';
import PacksBlock from '@/components/subscriptionPack/Packs.vue';

import SubscriptionEntity from '@/store/patients/subscriptions/entity';
import { formatDateForBackend, getTodayDate } from '@/utils/date';
import { subscriptionTypeMapper } from '@/utils/subscriptions';
import { SubscriptionPack } from "@/types/models/subscriptionTypes";
import { InputSuggestionItem } from '@/lib/formFactory/inputSuggestion.interface';
import { humanizeToRussian } from '@/utils/date/human';

export interface formSubmitData {
    subscriptionTypeId: number,
    start?: string,
    end?: string,
}

const defineForm = (defaults?: SubscriptionCard) => {
    if (defaults) {
        SubscriptionEntity.updateSuggestionsCurrentByType({
            type: 'subscriptionType',
            current: { id: defaults.subscriptionType.id, value: defaults.subscriptionType.title },
        });

        return {
            ...defaults,
            packs: (defaults.packs as SubscriptionPack[])?.map(subscriptionTypeMapper) || [],
        };
    }

    return {
        id: 0,
        title: '',
        periodicity: '',
        price: '',
        startAt: '',
        endAt: '',
        patientId: null,
        subscriptionType: { id: 0, title: '', price: 0, periodicity: 0 },
        patient: { id: 0, fullName: '' },
        packs: [],
        currentPacks: [],
        payments: [],
    }
}

const MINUTES_IN_ONE_MONTH = 44640;

@Component({
    components: {
        Form,
        InputBase,
        NumericInput,
        ErrorField,
        DatepickerPopup,
        InputSuggestions,
        PacksBlock,
    }
})
export default class SubscriptionsForm extends Form {
    @Prop({}) formValues?: SubscriptionCard;
    @Prop({ default: () => ({}) }) errors!: Errors;

    values: Record<string, any> = defineForm(this.formValues);
    titles = {
        startAt: 'Дата начала подписки',
        endAt: 'Дата окончания подписки',
    }

    get model() {
        return SubscriptionEntity.model;
    }

    get minStartAtDate() {
        return getTodayDate();
    }

    get minEndAtDate() {
        return this.values.startAt || this.minStartAtDate;
    }

    get humanMonths() {
        if (!this.values.subscriptionType.periodicity) {
            return '';
        }

        const periodicityAsNumber = +this.values.subscriptionType.periodicity;

        if (isNaN(periodicityAsNumber)) {
            return '';
        }

        const months = humanizeToRussian(periodicityAsNumber * MINUTES_IN_ONE_MONTH, { language: 'ru', greatest: true });
        const matchArray = months.match(/месяц[\S]*/);

        if (!matchArray) {
            return '';
        }

        return matchArray[0];
    }

    handleDate(params: { key: string; date: string }) {
        this.values[params.key] = formatDateForBackend(params.date, 'YYYY-MM-DD');
    }

    prepareData(): formSubmitData {
        const data: formSubmitData = {
            subscriptionTypeId: this.values.subscriptionType.id,
        };

        if (this.values.startAt) {
            data.start = this.values.startAt;
        }

        if (this.values.endAt) {
            data.end = this.values.endAt;
        }

        return data;
    }

    async update() {
        const data = this.prepareData();
        this.$emit('submit', data);
    }

    searchSubscriptionType(value: string) {
        SubscriptionEntity.searchSubscriptionType(value);
    }

    selectSubscriptionType(current: InputSuggestionItem) {
        SubscriptionEntity.updateSubscriptionType(current);
    }

    returnBefore() {
        this.$router.push({ name: 'medicalServiceTypes' });
    }
}
